import {Component, Input} from '@angular/core';
import {Store} from "@ngrx/store";

@Component({
  selector: 'brt-favorites-icon',
  templateUrl: './favorites-icon.component.html',
  styleUrls: ['./favorites-icon.component.scss']
})
export class FavoritesIconComponent {

  @Input('favoriteItemsNumber') favoriteItemsNumber = 0;

  constructor(private store: Store) { }
}
